<template>
  <v-menu
    :max-width="width"
    :min-width="width"
    nudge-bottom="48"
    left
    :activator="activator"
    :value="value"
    :close-on-click="false"
    @input="v => $emit('input', v)"
  >
    <template v-slot:activator="{on}">
      <v-btn v-on="on" icon>
        <v-icon>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-card>
      <OLoadingLine :value="isLoading" absolute class="mt-0" />
      <v-list dense>
        <v-list-item
          v-for="r in queryResults"
          :key="r.id"
          @click="$emit('rowClicked', r)"
        >
          <ORow fill-x stretch-x>
            <div style="width: 100px" class="grow-0 shrink-0">
              {{ r.timestamp | moment('DD/MMM/YYYY') }}
            </div>
            <div style="width: 50px" class="grow-0 shrink-0">
              <v-icon :color="r.color">mdi-square-rounded</v-icon>
              <!-- {{r.color}} -->
            </div>
            <div class="grow-1 single-line-ellipsis">{{ r.description }}</div>
          </ORow>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { Task } from '@/models'
import debounce from 'lodash/debounce'
import utils from 'oderon-commons/src/utils.js'

export default {
  props: {
    keywords: String,
    width: Number,
    activator: String,
    value: {}
  },
  watch: {
    keywords() {
      console.log('debounced query')
      this.debouncedFetchData()
    }
  },
  data() {
    return {
      isLoading: false,
      queryResults: [],
      debouncedFetchData: debounce(() => this.fetchData(), 250)
    }
  },
  methods: {
    async fetchData() {
      if ( utils.isEmpty(this.keywords) ) {
        this.queryResults = []
        return
      }

      try {
        this.isLoading = true
        this.queryResults = await Task.findAll({
          keywords: this.keywords,
          limit: 5,
          order: 'timestamp desc, id desc'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style></style>
